import { Component} from '@angular/core';

@Component({
    selector: 'city-main',
    templateUrl: './city-main.tmpl.html'
})

export class CityMain {
    editMode: boolean = null; 

    public setVal(val:boolean) {
        this.editMode = val;  
    }
}
  